import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  ErrorPaymentsIcon as ErrorIcon,
  ServiceError as ServiceErrorIcon,
} from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/pictures';
import { Agreement } from '@womcorp/wom-miwom-ui-kit/dist/components/Agreement';
import { navigate } from 'gatsby';
import Accordion from '../../CurrentInvoice/Accordion';
import Download from '../../Download';
import Loading from '../../../General/Loading';

import {
  ContentContainer,
  ErrorTemplateStyled,
  LoadingWrapper,
} from './styles/ItemContentStyled';

import InvoicesServices from '../../../../services/Invoices';
import { GoogleTagManager } from '../../../../helpers';

const ItemContent = ({
  total,
  documentId,
  dueDate,
  urlPdf,
  toggled,
  selectedAccount,
}) => {
  const [data, setData] = useState({});
  const [consumptionPeriod, setConsumptionPeriod] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [isInternalError, setIsInternalError] = useState(false);

  const loadData = () => {
    setError(false);
    setIsInternalError(false);
    setLoading(true);
    InvoicesServices.getInvoiceById(selectedAccount, documentId)
      .then(res => {
        const { categories, consumptionPeriod: consumptionPeriodData } = res[0];
        setData(categories);
        setConsumptionPeriod(consumptionPeriodData);
      })
      .catch(({ status }) => {
        setError(true);
        setIsInternalError(status === 429);
        GoogleTagManager.pushToDataLayer({
          event: 'pagina-virtual',
          page: '/mis-boletas/error-detalle-boleta',
          pagename: 'Boletas - Error Detalle Boletas',
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    if (!toggled) {
      setError(false);
      setLoading(true);
    }
  }, [toggled]);

  return (
    <ContentContainer key="content">
      {loading ? (
        <LoadingWrapper>
          <Loading />
        </LoadingWrapper>
      ) : (
        <>
          {error && (
            <>
              {!isInternalError ? (
                <ErrorTemplateStyled
                  icon={<ErrorIcon />}
                  title="Ha ocurrido un error"
                  onClickButton={loadData}
                  className="customError"
                >
                  <span>
                    No se ha podido completar tu solicitud, vuelve a intentarlo
                  </span>
                </ErrorTemplateStyled>
              ) : (
                <ErrorTemplateStyled
                  icon={<ServiceErrorIcon />}
                  title="Error Interno del Servidor"
                  buttonText="IR AL INICIO"
                  className="customError"
                  onClickButton={() => {
                    navigate('/home');
                  }}
                >
                  <span>Nuestro sistema ha fallado vuelve más tarde</span>
                </ErrorTemplateStyled>
              )}
            </>
          )}

          {!error && (
            <Accordion
              data={data}
              dueDate={dueDate}
              billingNumber={documentId}
              consumptionPeriod={consumptionPeriod}
              total={total}
            />
          )}
          <Download text="Ver Boleta" link={urlPdf} />
          <Agreement>
            <span>Ingresa para ver el detalle completo</span>
          </Agreement>
        </>
      )}
    </ContentContainer>
  );
};

ItemContent.propTypes = {
  total: PropTypes.number,
  documentId: PropTypes.string.isRequired,
  dueDate: PropTypes.string,
  urlPdf: PropTypes.string,
  toggled: PropTypes.bool.isRequired,
  selectedAccount: PropTypes.string.isRequired,
};

ItemContent.defaultProps = {
  total: 0,
  dueDate: '',
  urlPdf: '',
};

export default ItemContent;
